import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageEditing } from '../../../utils/sitecoreContext';
import appendQueryString from '../utils/appendQueryString';
import isSSR from '../../../utils/isSSR';
const noRedirect = { shouldRedirectBack: false, redirectUrl: '' };
const modelQueryParams = ['modelKey', 'modelYear'];
const requiredQueryParams = [
    'trimKey',
    'transmissionKey',
    'exteriorColorKey',
    'interiorColorKey',
    'inventoryStatus',
];
const useShouldRedirectBack = (activeStep, progressItems, dealerCode) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const isPageEditing = usePageEditing();
    const { pathname, search } = useLocation();
    const query = useMemo(() => new URLSearchParams(search), [search]);
    if (isSSR())
        return noRedirect;
    const isAtInventory = !!(progressItems === null || progressItems === void 0 ? void 0 : progressItems.find(item => { var _a, _b, _c; return ((_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.progressUrl) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.href) === pathname; }));
    // when outside inventory flow or in Content Editor, disable redirect
    if (!isAtInventory || isPageEditing)
        return noRedirect;
    const isModelSelected = modelQueryParams.every(params => !!query.get(params));
    const backToModel = (_d = (_c = (_b = (_a = progressItems[0]) === null || _a === void 0 ? void 0 : _a.progressUrl) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.href;
    // only add model related query strings
    const backToPickDealer = appendQueryString((_h = (_g = (_f = (_e = progressItems[1]) === null || _e === void 0 ? void 0 : _e.progressUrl) === null || _f === void 0 ? void 0 : _f.item) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.href, query, modelQueryParams);
    switch (activeStep) {
        case 0: // ['Choose Model']
            return noRedirect;
        case 1: // ['Pick Dealer']
            return { shouldRedirectBack: !isModelSelected, redirectUrl: backToModel };
        case 2: // ['Availability']
            return isModelSelected
                ? { shouldRedirectBack: !dealerCode, redirectUrl: backToPickDealer }
                : { shouldRedirectBack: true, redirectUrl: backToModel };
        case 3: {
            // ['Vehicle Details']
            if (!isModelSelected)
                return { shouldRedirectBack: true, redirectUrl: backToModel };
            // only keep model related query strings and strip others
            const backToAvailability = appendQueryString((_m = (_l = (_k = (_j = progressItems[2]) === null || _j === void 0 ? void 0 : _j.progressUrl) === null || _k === void 0 ? void 0 : _k.item) === null || _l === void 0 ? void 0 : _l.value) === null || _m === void 0 ? void 0 : _m.href, query, modelQueryParams);
            const allQueryParamsValid = requiredQueryParams.every(param => !!query.get(param));
            return dealerCode
                ? { shouldRedirectBack: !allQueryParamsValid, redirectUrl: backToAvailability }
                : { shouldRedirectBack: true, redirectUrl: backToPickDealer };
        }
        default:
            return noRedirect;
    }
};
export default useShouldRedirectBack;
